export default __webpack_public_path__ + "static/media/TeacherLearningCenterPicture.d603fde5.png";